import React, { useEffect } from "react";

// components
import {
  Button,  
  Modal,
  Row,
  Col   
} from "reactstrap";

// helpers
import {formateDateandTime} from "../../../helpers/formats.js";

// services
import { getSessionCookie} from "../../../services/session.js";

export default function ModalHistoricoAvaliacao({stateModalHistoricoAvaliacao, ordemColeta, handleReturn}) {
    const session = getSessionCookie();  
    const [stateModal, setstateModal] = React.useState(stateModalHistoricoAvaliacao);

    useEffect(() => {         
        setstateModal(stateModalHistoricoAvaliacao);
    }, [stateModalHistoricoAvaliacao]);

    
    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"                
            >     
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                    Histórico de Avaliação da Ordem
                    </h4>
                    <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"   
                    onClick={() => handleReturn()}                 
                    >
                    <span aria-hidden={true}>×</span>
                    </button>
                </div>           
                <div className="modal-body">                                           
                    <Row>
                        <Col md="12">
                            <div className="mt-4">
                                <h4 className="modal-title" id="modal-title-default">
                                    Lista de Ações
                                </h4>
                                <table class="table align-items-center mt-4">
                                    <thead class="thead-light">
                                        <tr>
                                            <th scope="col" class="sort" data-sort="status">Data</th>
                                            <th scope="col" class="sort" data-sort="name">Ação</th>
                                            <th scope="col" class="sort" data-sort="budget">Usuário</th>                                        
                                            <th scope="col">Tipo de Avaliação</th>                                            
                                        </tr>
                                    </thead>
                                    <tbody class="list">            
                                        {ordemColeta != null && ordemColeta.ordemColetaAvaliacao != null && ordemColeta.ordemColetaAvaliacao.sort(function(a,b){  return new Date(b.dataHoraRegistro) - new Date(a.dataHoraRegistro);})
                                        .map(m => (
                                            <tr key={m.id}>
                                                <td>{formateDateandTime(m.dataHoraRegistro)}</td>
                                                <td>{m.situacao}</td>
                                                <td>{m.usuario.nome}</td>                                            
                                                <td>{m.tipoAvaliacao}</td>
                                            </tr>
                                        ))}                                    
                                    </tbody>
                                </table>
                            </div>
                        </Col>                                                                
                    </Row>                                                  
                </div>
                <div className="modal-footer">
                <Button color="secondary" type="button" onClick={() => handleReturn()}>
                    Fechar
                </Button>                              
                </div>
            </Modal>
        </>
    );  
}
